import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

const About = () => {
  // List of images from art, formation, and about folders
  const artImages = [
    '/images/art/photo_1_2025-12-19_09-25-02.jpg',
    '/images/art/photo_2_2025-12-19_09-25-02.jpg',
    '/images/art/photo_3_2025-12-19_09-25-02.jpg',
  ];

  const formationImages = [
    '/images/formation/photo_11_2025-12-19_08-37-19.jpg',
    '/images/formation/photo_20_2025-12-19_08-37-19.jpg',
    '/images/formation/photo_21_2025-12-19_08-37-19.jpg',
    '/images/formation/photo_25_2025-12-19_08-37-19.jpg',
    '/images/formation/photo_26_2025-12-19_08-37-19.jpg',
  ];

  const aboutImages = [
    '/images/about/photo_12_2025-12-19_08-37-19.jpg',
    '/images/about/photo_15_2025-12-19_08-37-19.jpg',
  ];

  // Combine all images for random display
  const newImages = [...artImages, ...formationImages, ...aboutImages];

  const [displayedImages, setDisplayedImages] = useState([]);

  // Function to get 4 random images
  const getRandomImages = () => {
    const shuffled = [...newImages].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 4);
  };

  useEffect(() => {
    // Set initial random images
    setDisplayedImages(getRandomImages());
    
    // Change images every 5 seconds
    const interval = setInterval(() => {
      setDisplayedImages(getRandomImages());
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Helmet>
        <title>À propos | Royal Nails Pro - Salon Manucure Genève</title>
        <link rel="canonical" href="https://royalnailspro.ch/about" />
        <meta
          name="description"
          content="Découvrez Royal Nails Pro - salon de manucure professionnel à Genève. Prothésiste ongulaire certifiée spécialisée dans les manucures élégantes, le façonnage précis et une beauté durable."
        />
        <meta
          name="keywords"
          content="à propos Royal Nails Pro, salon manucure Genève, prothésiste ongulaire Genève, histoire salon ongles, manucure professionnelle Genève, nail art Genève"
        />
        
        {/* Open Graph / Facebook & Instagram */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://royalnailspro.ch/about" />
        <meta property="og:title" content="À propos | Royal Nails Pro - Salon Manucure Genève" />
        <meta property="og:description" content="Découvrez Royal Nails Pro - salon de manucure professionnel à Genève. Prothésiste ongulaire certifiée spécialisée dans les manucures élégantes." />
        <meta property="og:image" content="https://royalnailspro.ch/images/about.png" />
        <meta property="og:image:secure_url" content="https://royalnailspro.ch/images/about.png" />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:alt" content="À propos Royal Nails Pro" />
        <meta property="article:author" content="https://www.facebook.com/people/Rodyka-Soltan/61572131475024/" />
        
        {/* Instagram specific */}
        <meta property="instagram:creator" content="@rodyka_soltan" />
        
        {/* TikTok */}
        <meta name="tiktok:creator" content="@rodicasoltan" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="À propos | Royal Nails Pro" />
        <meta name="twitter:description" content="Découvrez Royal Nails Pro - salon de manucure professionnel à Genève." />
        <meta name="twitter:image" content="https://royalnailspro.ch/images/about.png" />
        <meta name="twitter:site" content="@rodyka_soltan" />
        <meta name="twitter:creator" content="@rodyka_soltan" />
      </Helmet>

      <div className="back_re">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="title">
                <h2>À propos</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="about slin2">
        <div className="container">
          <div className="row d_flex">
            <div className="col-md-6">
              <div className="titlepage">
                <h2>À propos</h2>
                <p>
                  Bienvenue chez Geneva Manucure – Royal Nails Pro, l'adresse incontournable pour
                  des ongles impeccables à Genève. Dans notre salon, l'art de la perfection est une
                  véritable signature. En tant que prothésiste ongulaire certifiée, je suis
                  spécialisée dans les manucures élégantes, le façonnage précis et une beauté
                  durable.
                </p>
                <p>
                  Que vous souhaitiez une sophistication classique, un look naturel et soigné ou un
                  nail art audacieux, chaque prestation est réalisée avec créativité, minutie et
                  passion.
                </p>
                <p>
                  Chez Geneva Manucure – Royal Nails Pro, vos mains méritent l'excellence — et nous
                  ne vous offrons rien de moins.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="about_img">
                <figure>
                  <img src="/images/about.png" alt="About" />
                </figure>
              </div>
            </div>
          </div>
          
          {/* Random Images Row */}
          <div className="row mt-5">
            <div className="col-md-12">
              <div className="row">
                {displayedImages.map((image, index) => (
                  <div key={index} className="col-md-3 col-sm-6 mb-4">
                    <div 
                      style={{
                        width: '100%',
                        height: '250px',
                        overflow: 'hidden',
                        borderRadius: '8px',
                        boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                        transition: 'transform 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.05)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    >
                      <img 
                        src={image} 
                        alt={`Gallery ${index + 1}`}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          transition: 'opacity 0.5s ease'
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;

